
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/living/why-now",
      function () {
        return require("private-next-pages/living/why-now.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/living/why-now"])
      });
    }
  